import React, { useContext, useState, useEffect } from "react";
import { Context } from "../../../Context";
import { BranchOfficeView } from "../../views";
import { SimpleLoading, ModalUtil } from "../../pures";
import { LocalStorageService, BranchOfficeService } from "../../../services";
import { useTranslation } from "react-i18next";
import "moment/locale/es";

/**
 * @class BranchOfficeAction
 * @extends {React.Component}
 * @status no delete
 */
const BranchOfficeAction = (props) => {
  const { t } = props
  const [filter, setFilter] = useState([])
  const [showLoadingRequesting, setShowLoadingRequesting] = useState(false)
  const [showCompletedRequesting, setShowCompletedRequesting] = useState(false)
  const [showErrorRequesting, setShowErrorRequesting] = useState(false)
  const [initialLoading, setInitialLoading] = useState(true)
  const [stateSortStart, setStateSortStart] = useState(0)
  const [stateSortLimit, setStateSortLimit] = useState(0)
  const [branchOffices, setBranchOffices] = useState([])

  const url = process.env.REACT_APP_ETICKET_API;
  const localStorageService = new LocalStorageService();
  const branchOfficeService = new BranchOfficeService(url)
  const modalUtil = new ModalUtil()

  useEffect(() => {
    getBranchOffices()
  }, [])

  const getBranchOffices = async () => {
    try {
      const token = JSON.parse(localStorage.getItem('token')).accessToken
      const branchOffices = await branchOfficeService.getBranchOffices(token)
      setBranchOffices(branchOffices)
      setInitialLoading(false)
    } catch (error) {
      props.setShowError(true)
      setInitialLoading(false)
    }
  }

  const changeStateFilter = (sortStart, sortLimit) => {
    let startState = sortStart;
    let limitState = sortLimit;

    if (startState >= 0 && limitState === undefined) {
      startState += 1;
      if (startState < 3) {
        this.setState({
          stateSortStart: startState,
        });
      } else if (startState === 3) {
        startState = 0;
        this.setState({
          stateSortStart: startState,
        });
      }
    } else if (limitState >= 0 && startState === undefined) {
      limitState += 1;
      if (limitState < 3) {
        this.setState({
          stateSortLimit: limitState,
        });
      } else if (limitState === 3) {
        limitState = 0;
        this.setState({
          stateSortLimit: limitState,
        });
      }
    }
    this.filterByState(startState, limitState);
  };

  /**
   * @author Brayan Salas
   * @description
   * @param {Object} dataItem
   * @memberof BranchOfficeAction
   */
  const toggleLoadingRequesting = (value) => {
    setInitialLoading(value)
  }

  /**
   * @author Brayan Salas
   * @description
   * @param {Object} dataItem
   * @memberof BranchOfficeAction
   */
  const toggleCompletedRequesting = (value) => {
    setShowCompletedRequesting(value)
    setTimeout(() => { setShowCompletedRequesting(false) }, 4000)
  };

  /**
   * @author Brayan Salas
   * @description
   * @memberof BranchOfficeAction
   */
  const toggleErrorRequesting = (value) => {
    setShowErrorRequesting(value)
    setTimeout(() => { setShowErrorRequesting(false) }, 4000)
  };

  const deleteBranchOffice = async (branchOffice) => {
    try {
      modalUtil.showModal('loading', t("modal.pure.loading.message"), t("modal.pure.loading.title"))
      const token = localStorageService.getLocalStorageItem('token').accessToken

      const branchOfficeDeleted = await branchOfficeService.deleteBranchOffice(branchOffice.id, token)
      if (branchOfficeDeleted) modalUtil.showModal('success', 'La sucursal fue eliminada', t("modal.pure.title.success"), getBranchOffices)
    } catch (error) {
      console.log(error)
      modalUtil.showModal('error', 'La sucursal no fue agregada', t("modal.pure.title.error"))
    }
  }

  return (
    <>
      {
        initialLoading ?
          <div className="loading">
            <SimpleLoading />
          </div> : <BranchOfficeView
            branchOffices={branchOffices}
            setData={setBranchOffices}
            filter={filter}
            showLoadingRequesting={showLoadingRequesting}
            showCompletedRequesting={showCompletedRequesting}
            showErrorRequesting={showErrorRequesting}
            initialLoading={initialLoading}
            stateSortStart={stateSortStart}
            stateSortLimit={stateSortLimit}
            view={"/"}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleCompletedRequesting={toggleCompletedRequesting}
            toggleErrorRequesting={toggleErrorRequesting}
            filterByState={changeStateFilter}
            deleteBranchOffice={deleteBranchOffice}
          />
      }
    </>
  )
}

function BranchOfficeActionContainer(props) {
  const { t } = useTranslation();
  const { setShowError } = useContext(Context);
  return (
    <BranchOfficeAction {...props} t={t} setShowError={setShowError} />
  );
}

export { BranchOfficeActionContainer as default };
